import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getUserId } from "../../../AsianExchangeSrc/utils/helper/commonSelectors";
import { getLoginRecord } from "../../../AsianExchangeSrc/api";
import Loader from "../../../AsianExchangeSrc/utils/Loader";
import CommonTable from "../../components/TableComponent/TableComponent";
import { toast } from "react-toastify"; // Assuming toast is used for error notifications

const ActiveLogs = () => {
  const [activeLogs, setActiveLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const userID = useSelector(getUserId());

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}`;
  };

  useEffect(() => {
    const fetchActiveData = async () => {
      setLoading(true);
      try {
        const loginRecord = await getLoginRecord(userID);
        setActiveLogs(
          [...loginRecord.data.data].reverse().map((log) => ({
            id: log._id,
            dateTime: formatDate(log.createdAt),
            status: log.status === "success" ? "Login Success" : "Login Failed",
            ipAddress: log.query || "-",
            isp: log.isp || "-",
            location: log.cityStateCountry || "-",
          }))
        );
      } catch (error) {
        toast.error(error?.response?.data?.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };
    fetchActiveData();
  }, [userID]);

  const columns = [
    { key: "dateTime", header: "Date/Time", mobileLabel: "Date/Time" },
    {
      key: "status",
      header: "Login Status",
      mobileLabel: "Status",
      renderCell: (row) => (
        <span
          className={
            row.status === "Login Success" ? "text-green-500" : "text-red-500"
          }
        >
          {row.status}
        </span>
      ),
    },
    { key: "ipAddress", header: "IP Address", mobileLabel: "IP" },
    { key: "isp", header: "ISP", mobileLabel: "ISP" },
    { key: "location", header: "Location", mobileLabel: "Location" },
  ];

  return (
    <div className="mx-auto bg-light-bg dark:bg-dark-bg rounded-t-lg mx-1">
      {loading && <Loader />}
      {!loading && (
        <CommonTable
          title="Active Log"
          data={activeLogs}
          columns={columns}
          showEntriesOptions={[10, 25, 50, 100]}
          initialEntriesPerPage={10}
          showPagination={true}
          emptyMessage="No login records found"
        />
      )}
    </div>
  );
};

export default ActiveLogs;